"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormWatcher = void 0;
const react_hook_form_1 = require("react-hook-form");
const FormWatcher = props => {
    const { name } = props;
    const form = name ? (0, react_hook_form_1.useWatch)({ name }) : (0, react_hook_form_1.useWatch)();
    console.info(form);
    return null;
};
exports.FormWatcher = FormWatcher;
//# sourceMappingURL=watch.js.map